export default __webpack_public_path__ + "assets/attendant-component.5a117e56.svg";